import {Button} from "@consta/uikit/Button";
import {Modal} from "@consta/uikit/Modal";
import React, {useEffect, useState} from "react";
import {read, utils} from "xlsx";
import axios from "axios";
import {API_GRAPH_PAYLOAD} from "../../../service/api.endpoint";
import '../tooltip.css'
import {ProgressStepBar} from "@consta/uikit/ProgressStepBar";
import {ProgressLine} from '@consta/uikit/ProgressLine';
import {IconCheck} from "@consta/uikit/IconCheck";
import {IconClose} from "@consta/uikit/IconClose";
import cookieCmp from "../../../component/cookie.cmp";
import {Text} from '@consta/uikit/Text';
import moment from "moment";

interface ModalComponentProps {
    isOpen: boolean;
    onClose: any;
    props: any
}

type StatusProgressBarType = 'normal' | 'success' | 'alert' | 'warning' | undefined;

type ItemProgressBarType = {
    label: string;
    tooltipContent?: string;
    point?: number;
    progress?: boolean;
    status?: StatusProgressBarType;
    lineStatus?: StatusProgressBarType;
};

const GRAPH_SHEETS = ['ВОСТОК', 'СЕВЕР', 'ЗАПАД', 'ЮГ', 'Салым'];


// чтени эксель файла
async function xlsRead(props: Blob) {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.onload = (e: any) => {
            try {
                const data = new Uint8Array(e.target.result);
                const workbook = read(data, {type: 'array'});

                const sheetNames = workbook.SheetNames;
                const jsonData: any = {};

                sheetNames.forEach((sheetName) => {
                    const worksheet = workbook.Sheets[sheetName];
                    jsonData[sheetName] = utils.sheet_to_json(worksheet, {header: 1});
                });
                resolve(jsonData);
            } catch (error) {
                reject(error);
            }
        };
        fileReader.onerror = (error) => {
            reject(error);
        };
        fileReader.readAsArrayBuffer(props);
    });
}


// Получение CSRF токена из cookies
const csrftoken = cookieCmp('csrftoken');

// Установка CSRF токена в заголовок запроса
axios.defaults.headers.post['X-CSRFToken'] = csrftoken;

const ModalGraphImportXLS: React.FC<ModalComponentProps> = ({props, isOpen, onClose}) => {
    const [modalOpen, setModalOpen] = useState(isOpen);
    // дата из файла загрузки
    const [xlsDate, setXlsDate] = useState('')
    const [xlsHeaderCount, setXlsHeaderCount] = useState(0)
    const [jsonData, setJsonData] = useState<any>([])
    const [sbStatus, setSbStatus] = useState<StatusProgressBarType[]>(['normal', 'normal', 'normal', 'normal'])
    const [sbLineStatus, setSbLineStatus] = useState<StatusProgressBarType[]>(['normal', 'normal', 'normal', 'normal'])
    const [sbProgress1, setSbProgress1] = useState<boolean>(false)
    const [sbProgress2, setSbProgress2] = useState<boolean>(false)
    const [sbProgress3, setSbProgress3] = useState<boolean>(false)
    const [sbProgress4, setSbProgress4] = useState<boolean>(false)
    const [sbPoint1, setSbPoint1] = useState<any>(1)
    const [sbPoint2, setSbPoint2] = useState<any>(2)
    const [sbPoint3, setSbPoint3] = useState<any>(3)
    const [sbPoint4, setSbPoint4] = useState<any>(4)
    const [activeStepIndex, setActiveStepIndex] = useState<number>(0)
    const [pgLineValue, setPgLineValue] = useState<number | undefined>(undefined)
    const [pgVisible, setPgVisible] = useState<boolean>(false)
    const [isSaveDisabled, setIsSaveDisabled] = useState<boolean>(false)
    const [isFinishImport, setIsFinishImport] = useState<string | undefined>()
    const [isCloseDisabled, setIsCloseDisabled] = useState<boolean>(false)
    const [textError, setTextError] = useState<any>(null)
    const [isValidated, setIsValidated] = useState<boolean>(false)


    const steps: ItemProgressBarType[] = [
        {
            label: 'Проверяем кусты',
            point: sbPoint1,
            progress: sbProgress1,
            status: sbStatus[0],
            lineStatus: sbLineStatus[0],
            tooltipContent: `Небольшое описание выполнения или состояния на шаге 1`,
        },
        {
            label: 'Проверяем скважины',
            point: sbPoint2,
            status: sbStatus[1],
            progress: sbProgress2,
            lineStatus: sbLineStatus[1],
            tooltipContent: `Небольшое описание выполнения или состояния на шаге 2`,
        },
        {
            label: 'Проверяем дубли',
            point: sbPoint3,
            status: sbStatus[2],
            progress: sbProgress3,
            lineStatus: sbLineStatus[2],
            tooltipContent: `Небольшое описание выполнения или состояния на шаге 3`,
        },
        {
            label: 'Загрузка после подтверждения',
            point: sbPoint4,
            status: sbStatus[3],
            progress: sbProgress4,
            lineStatus: sbLineStatus[3],
            tooltipContent: `Небольшое описание выполнения или состояния на шаге 4`,
        },

    ];
    // useEffect(() => {
    //     setModalOpen(isOpen);
    // }, [isOpen]);

    const handleCloseModal = () => {
        setModalOpen(false);
        onClose();
    };

    const resetImportState = () => {
        setSbStatus(['normal', 'normal', 'normal', 'normal'])
        setSbLineStatus(['normal', 'normal', 'normal', 'normal'])
        setSbProgress1(false)
        setSbProgress2(false)
        setSbProgress3(false)
        setSbProgress4(false)
        setSbPoint1(1)
        setSbPoint2(2)
        setSbPoint3(3)
        setSbPoint4(4)
        setActiveStepIndex(0)
        setPgLineValue(undefined)
        setPgVisible(false)
        setIsSaveDisabled(false)
        setIsFinishImport(undefined)
        setIsCloseDisabled(false)
        setTextError(null)
        setIsValidated(false)
    }

    const progressBarOperand = (element: number, lineStatus?: StatusProgressBarType, status?: StatusProgressBarType, activeStep?: number) => {
        if (lineStatus) {
            setSbLineStatus(prevLineStatus => {
                const updatedSbLineStatus = [...prevLineStatus];
                updatedSbLineStatus[element] = lineStatus;
                return updatedSbLineStatus;
            });
        }
        if (status) {
            setSbStatus(prevStatus => {
                const updatedSbStatus = [...prevStatus];
                updatedSbStatus[element] = status;
                return updatedSbStatus;
            });
        }
        if (activeStep !== undefined) {
            setActiveStepIndex(activeStep);
        }
    };

    const getDayColumns = (header: any[] = []) => header
        .map((cell: any, index: number) => ({cell: String(cell || '').trim(), index}))
        .filter((item: any) => {
            const value = Number(item.cell)
            return Number.isInteger(value) && value >= 1 && value <= 31
        })
        .sort((a: any, b: any) => Number(a.cell) - Number(b.cell))

    const getEffectiveHeaderCount = () => {
        for (const sheetName of GRAPH_SHEETS) {
            const header = jsonData?.[sheetName]?.[8] || []
            const dayColumns = getDayColumns(header)

            if (dayColumns.length > 0) {
                return dayColumns.length + 22
            }
        }

        return xlsHeaderCount
    }

    const buildSplitLists = () => {
        const importData = getGraphSheetsData()
        const effectiveHeaderCount = getEffectiveHeaderCount()
        const listArr = [{sheet: "ВОСТОК", data: importData['ВОСТОК']?.slice(9,)}, {
            sheet: "СЕВЕР",
            data: importData['СЕВЕР']?.slice(9,)
        }, {sheet: "ЗАПАД", data: importData['ЗАПАД']?.slice(9,)}, {
            sheet: "ЮГ",
            data: importData['ЮГ']?.slice(9,)
        }, {sheet: "Салым", data: importData['Салым']?.slice(9,)}]

        const splitLists: any[][] = [];
        listArr.forEach((list) => {
            if (list.data) {
                const chunkSize = Math.ceil(list.data.length / 5);
                for (let i = 0; i < list.data.length; i += chunkSize) {
                    const chunk = list.data.slice(i, i + chunkSize);
                    chunk.unshift(effectiveHeaderCount);
                    chunk.unshift(xlsDate[0] !== "0" ? xlsDate[0] : xlsDate);
                    chunk.unshift(list.sheet);
                    splitLists.push(chunk);
                }
            }
        });

        return splitLists
    }

    const getGraphSheetsData = () => {
        const result: any = {}

        GRAPH_SHEETS.forEach((sheetName) => {
            const sheetData = jsonData?.[sheetName]

            if (!Array.isArray(sheetData)) {
                return
            }

            result[sheetName] = sheetData.map((row: any, rowIndex: number) => {
                if (rowIndex < 9 || !Array.isArray(row)) {
                    return row
                }

                const hasRequiredGraphFields = !isEmptyCell(row[1]) && !isEmptyCell(row[3]) && !isEmptyCell(row[5])
                return hasRequiredGraphFields ? row : []
            })
        })

        return result
    }

    const toNumber = (value: any): number => {
        if (value === undefined || value === null || value === '') {
            return 0
        }

        const normalized = String(value).replace(',', '.').trim()
        const result = Number(normalized)
        return Number.isFinite(result) ? result : NaN
    }

    const isEmptyCell = (value: any): boolean => value === undefined || value === null || String(value).trim() === ''

    const normalizeDuplicateKeyPart = (value: any): string => String(value || '')
        .trim()
        .replace(/\s+/g, '')
        .replace(/ё/g, 'е')
        .replace(/Ё/g, 'Е')
        .toLocaleUpperCase('ru-RU')

    const validatePlanCells = () => {
        const errors: any[] = []
        const wellsByKey = new Map<string, any>()

        GRAPH_SHEETS.forEach((sheetName) => {
            const sheetData = jsonData[sheetName]
            const header = sheetData?.[8] || []

            if (!sheetData) {
                return
            }

            const dayColumns = getDayColumns(header)

            const planColumnIndex = header.findIndex((cell: any) => {
                const text = String(cell || '').toLowerCase().trim()
                return text === 'итого план' || text === 'план'
            })

            if (dayColumns.length === 0 || planColumnIndex === -1) {
                errors.push({
                    type: 'excel',
                    sheet: sheetName,
                    message: 'Не найдены столбцы дней 1-31 или столбец плана',
                })
                return
            }

            sheetData.slice(9).forEach((row: any, rowIndex: number) => {
                if (!row || row.length === 0) {
                    return
                }

                if (isEmptyCell(row[1]) || isEmptyCell(row[3]) || isEmptyCell(row[5])) {
                    return
                }

                const duplicateKey = [
                    normalizeDuplicateKeyPart(row[3]),
                    normalizeDuplicateKeyPart(row[1]),
                    normalizeDuplicateKeyPart(row[5]),
                ].join('|')
                const firstRow = wellsByKey.get(duplicateKey)

                if (firstRow) {
                    errors.push({
                        type: 'excel',
                        sheet: sheetName,
                        rowNumber: rowIndex + 10,
                        deposit: row[3],
                        bush: row[1],
                        well: row[5],
                        message: `Дубль скважины. Уже есть на листе ${firstRow.sheet}, строка ${firstRow.rowNumber}`,
                    })
                } else {
                    wellsByKey.set(duplicateKey, {
                        sheet: sheetName,
                        rowNumber: rowIndex + 10,
                    })
                }

                let daySum = 0

                dayColumns.forEach((dayColumn: any) => {
                    const rawValue = row[dayColumn.index]
                    const value = toNumber(rawValue)

                    if (Number.isNaN(value)) {
                        errors.push({
                            type: 'excel',
                            sheet: sheetName,
                            rowNumber: rowIndex + 10,
                            deposit: row[3],
                            bush: row[1],
                            well: row[5],
                            message: `День ${dayColumn.cell}: значение не является числом`,
                        })
                        return
                    }

                    if (value > 1) {
                        errors.push({
                            type: 'excel',
                            sheet: sheetName,
                            rowNumber: rowIndex + 10,
                            deposit: row[3],
                            bush: row[1],
                            well: row[5],
                            message: `День ${dayColumn.cell}: значение ${rawValue}, должно быть не больше 1`,
                        })
                    }

                    daySum += value
                })

                const rawPlan = row[planColumnIndex]
                const planValue = toNumber(rawPlan)

                if (isEmptyCell(rawPlan)) {
                    errors.push({
                        type: 'excel',
                        sheet: sheetName,
                        rowNumber: rowIndex + 10,
                        deposit: row[3],
                        bush: row[1],
                        well: row[5],
                        message: `План пустой, должен быть ${daySum}`,
                    })
                    return
                }

                if (Number.isNaN(planValue)) {
                    errors.push({
                        type: 'excel',
                        sheet: sheetName,
                        rowNumber: rowIndex + 10,
                        deposit: row[3],
                        bush: row[1],
                        well: row[5],
                        message: 'План должен быть числом',
                    })
                    return
                }

                if (planValue !== daySum) {
                    errors.push({
                        type: 'excel',
                        sheet: sheetName,
                        rowNumber: rowIndex + 10,
                        deposit: row[3],
                        bush: row[1],
                        well: row[5],
                        message: `План ${planValue}, сумма дней ${daySum}`,
                    })
                }
            })
        })

        return errors
    }

    // Данные из экселя
    const getXlsRead = async () => {
        // Вспомогательная функция для проверки, является ли значение строкой
        const isString = (val: any): boolean => typeof val === 'string';

        // Вспомогательная функция для преобразования Excel-числа в дату
        const convertExcelDate = (excelNumber: number): string => {
            const baseDate = moment('1900-01-01');
            return baseDate.add(excelNumber - 2, 'days').format('DD.MM.YYYY');
        };

        // Вспомогательная функция для обработки листа Excel
        const processSheet = (sheetData: any) => {
            if (!sheetData || sheetData.length === 0) return;
            const firstCell = sheetData[0][0];
            if (isString(firstCell)) {
                setXlsDate(firstCell);
            } else {
                setXlsDate(convertExcelDate(firstCell));
            }
            setXlsHeaderCount(sheetData[8]?.length || 0);
        };

        // Основная логика функции
        try {
            resetImportState()
            const result: any = await xlsRead(props);
            setJsonData(result);

            for (const sheet of GRAPH_SHEETS) {
                if (result[sheet]) {
                    processSheet(result[sheet]);
                    break;
                }
            }
        } catch (error) {
            console.error('Error reading Excel file:', error);
        }
    };

    useEffect(() => {
        if (props) {
            getXlsRead()
        }
    }, [isOpen, props]);

    const handleValidate = async () => {
            if (props) {
                let errorCounter = 0;

                try {
                    console.log("▶️ START CHECK PROCESS");

                    setIsSaveDisabled(true);
                    setIsCloseDisabled(true);
                    setIsValidated(false)
                    setIsFinishImport(undefined)
                    setTextError(null)
                    setPgVisible(false)
                    setPgLineValue(undefined)
                    setSbPoint1(1)
                    setSbPoint2(2)
                    setSbPoint3(3)
                    setSbPoint4(4)
                    setSbStatus(['normal', 'normal', 'normal', 'normal'])
                    setSbLineStatus(['normal', 'normal', 'normal', 'normal'])

                    const planErrors = validatePlanCells()
                    if (planErrors.length > 0) {
                        setTextError(planErrors)
                        setSbPoint1(IconClose)
                        progressBarOperand(0, "warning", "warning", 0)
                        setIsFinishImport('error')
                        setIsSaveDisabled(false)
                        setIsCloseDisabled(false)
                        return
                    }
                    const graphSheetsData = getGraphSheetsData()

                    // ПРОВЕРКА КУСТОВ
                    setSbProgress1(true);
                    console.log("📤 Отправка запроса check_bush:", graphSheetsData);

                    const result_bush = await axios.post(
                        API_GRAPH_PAYLOAD,
                        {data: graphSheetsData, action: "check_bush"},
                        {headers: {"X-CSRFToken": csrftoken}}
                    );

                    setSbProgress1(false);
                    console.log("✅ Ответ check_bush:", result_bush.data);

                    if (result_bush.data?.status === "success") {
                        setSbPoint1(IconCheck);
                        progressBarOperand(0, "success", "success", 1);

                        // ПРОВЕРКА СКВАЖИН
                        setSbProgress2(true);
                        console.log("📤 Отправка запроса check_wells:", graphSheetsData);

                        const result_wells = await axios.post(
                            API_GRAPH_PAYLOAD,
                            {data: graphSheetsData, action: "check_wells"},
                            {headers: {"X-CSRFToken": csrftoken}}
                        );

                        setSbProgress2(false);
                        console.log("✅ Ответ check_wells:", result_wells.data);

                        if (result_wells.data?.status === "success") {
                            setSbPoint2(IconCheck);
                            progressBarOperand(1, "success", "success", 2);

                            // ПРОВЕРКА ДУБЛЕЙ В ТЕКУЩЕМ ГРАФИКЕ
                            setSbProgress3(true);
                            console.log("📤 Отправка запроса check_existing_graph:", graphSheetsData);

                            const result_existing = await axios.post(
                                API_GRAPH_PAYLOAD,
                                {data: graphSheetsData, action: "check_existing_graph"},
                                {headers: {"X-CSRFToken": csrftoken}}
                            );

                            setSbProgress3(false);
                            console.log("✅ Ответ check_existing_graph:", result_existing.data);

                            if (result_existing.data?.status === "success") {
                                setSbPoint3(IconCheck);
                                progressBarOperand(2, "success", "success", 3);
                                setIsValidated(true)
                                setIsFinishImport('ready')
                                setIsCloseDisabled(false)
                            } else {
                                console.warn("❌ Найдены дубли в текущем графике:", result_existing.data);
                                setTextError(result_existing.data.elements || []);
                                setSbPoint3(IconClose);
                                progressBarOperand(2, "warning", "warning", 2);
                                errorCounter += 1;
                            }

                        } else {
                            console.warn("❌ Ошибка в check_wells:", result_wells.data);
                            setTextError(result_wells.data.elements || []);
                            setSbPoint2(IconClose);
                            progressBarOperand(1, "warning", "warning", 1);
                            errorCounter += 1;
                        }
                    } else {
                        console.warn("❌ Ошибка в check_bush:", result_bush.data);
                        setTextError(result_bush.data.elements || []);
                        setSbPoint1(IconClose);
                        progressBarOperand(0, "warning", "warning", 0);
                        errorCounter += 1;
                    }
                } catch (error: any) {
                    console.error("💥 ГЛОБАЛЬНАЯ ОШИБКА try/catch", error);

                    if (error.response) {
                        console.error("📩 Ответ сервера с ошибкой:", error.response.data);
                    } else if (error.request) {
                        console.error("📡 Запрос был отправлен, но ответа нет:", error.request);
                    } else {
                        console.error("⚙️ Ошибка при настройке запроса:", error.message);
                    }

                    errorCounter += 1;
                }

                if (errorCounter === 0) {
                    setIsSaveDisabled(false)
                    console.log("ФАЙЛ ПРОВЕРЕН БЕЗ ОШИБОК")
                } else {
                    setIsValidated(false)
                    setIsSaveDisabled(false)
                    setIsCloseDisabled(false)
                    setIsFinishImport('error')

                    console.log("Исправьте ошибки")
                }
            }
        }
    ;

    const handleUpload = async () => {
            if (!isValidated) {
                return
            }

            const splitLists = buildSplitLists()
            let errorCounter = 0;

            try {
                setIsSaveDisabled(true);
                setIsCloseDisabled(true);
                setPgVisible(true);
                setPgLineValue(0);

                setSbProgress4(true);
                console.log("🔄 Начинается insert, всего батчей:", splitLists.length);

                for (let i = 0; i < splitLists.length; i++) {
                    const arr = splitLists[i];
                    console.log(`📤 Отправка insert #${i + 1}`, arr);

                    const result_insert = await axios.post(
                        API_GRAPH_PAYLOAD,
                        {data: arr, action: "insert"},
                        {
                            headers: {"X-CSRFToken": csrftoken}
                        });

                    console.log(`✅ Ответ insert #${i + 1}`, result_insert.data);

                    if (result_insert.data?.status === "success") {
                        setPgLineValue(prev => (prev !== undefined ? prev + 1 : 0));
                    } else {
                        console.warn(`❌ Ошибка insert #${i + 1}`, result_insert.data);
                        setSbPoint4(IconClose);
                        progressBarOperand(3, "warning", "warning", 3);
                        errorCounter += 1;
                    }
                }

                if (errorCounter === 0) {
                    const result_insert_prod = await axios.post(API_GRAPH_PAYLOAD, {data: null, action: 'insert_prod'}, {
                        headers: {
                            'X-CSRFToken': csrftoken
                        }
                    });
                    if (result_insert_prod.data['status'] === 'success') {
                        progressBarOperand(3, 'success', 'success', 3);
                        setSbProgress4(false)
                        setSbPoint4(IconCheck)
                        setIsFinishImport('success')
                        setIsValidated(false)
                        setIsCloseDisabled(false)
                    }
                    console.log("ВСЕ ГОТОВО БЕЗ ОШИБОК!")
                } else {
                    setIsCloseDisabled(false)
                    setIsFinishImport('error')
                    console.log("Исправьте ошибки")
                }
            } catch (error: any) {
                console.error("💥 ОШИБКА ЗАГРУЗКИ", error);
                setSbProgress4(false)
                setSbPoint4(IconClose)
                progressBarOperand(3, "warning", "warning", 3);
                setIsFinishImport('error')
                setIsCloseDisabled(false)
            } finally {
                setIsSaveDisabled(false)
            }
        }
    ;

    const renderTextErrors = () => {
        if (!Array.isArray(textError) || textError.length === 0) {
            return <Text>Проверка завершилась ошибкой, но сервер не вернул список проблем.</Text>
        }

        if (textError?.[0]?.type === 'excel') {
            return (
                <>
                    <Text weight='black'>Исправьте ошибки в файле Excel:</Text>
                    {textError.slice(0, 80).map((error: any, index: number) => (
                        <Text key={index}>
                            {error.sheet && `лист ${error.sheet}; `}
                            {error.rowNumber && `строка ${error.rowNumber}; `}
                            {error.deposit && `м/р ${error.deposit}; `}
                            {error.bush && `куст ${error.bush}; `}
                            {error.well && `скважина ${error.well}; `}
                            {error.message}
                        </Text>
                    ))}
                    {textError.length > 80 && (
                        <Text>Показаны первые 80 ошибок из {textError.length}.</Text>
                    )}
                </>
            );
        }

        if (textError?.[0]?.type === 'existing_graph') {
            return (
                <>
                    <Text weight='black'>Эти скважины уже есть в графике за выбранный месяц:</Text>
                    {textError.slice(0, 80).map((error: any, index: number) => (
                        <Text key={index}>
                            {error.sheet && `лист ${error.sheet}; `}
                            м/р {error.deposit}; куст {error.bush}; скважина {error.well}; подрядчик {error.org || '—'}
                        </Text>
                    ))}
                    {textError.length > 80 && (
                        <Text>Показаны первые 80 дублей из {textError.length}.</Text>
                    )}
                </>
            );
        }

        return (
            <>
                <Text weight='black'>Добавьте следующие {textError[0]['well'] ? 'скважины:' : 'кусты:'}</Text>
                {textError.map((error: any, index: number) => (

                    <Text
                        key={index}>м/р {error['deposit']} Куст {error['bush']} {error['well'] && `скважина ${error['well']}`}</Text>
                ))}
            </>
        );
    };

    const fileName = props?.name || 'Файл не выбран'
    const availableSheets = GRAPH_SHEETS.filter((sheetName) => jsonData?.[sheetName])
    const rowsCount = availableSheets.reduce((sum, sheetName) => {
        const rows = jsonData?.[sheetName]?.slice(9)?.filter((row: any) => row && row.length > 0).length || 0
        return sum + rows
    }, 0)
    const statusText = isFinishImport === 'success'
        ? 'Импорт завершён'
        : isFinishImport === 'ready'
            ? 'Файл проверен'
            : isFinishImport === 'error'
                ? 'Найдены ошибки'
                : 'Ожидает проверки'
    const statusClassName = isFinishImport ? `is-${isFinishImport}` : ''


    return (
        <Modal
            className='xlsImportModal'
            isOpen={isOpen}
            hasOverlay
            onEsc={onClose}
            onClose={handleCloseModal}
        >
            <div className="graph-import-modal">
                <div className="graph-import-head">
                    <div>
                        <h3>Загрузить основной график</h3>
                        <div>Excel-файл будет сначала проверен. Загрузка в базу станет доступна только после успешной проверки.</div>
                    </div>
                    <button type="button" onClick={onClose} disabled={isCloseDisabled}>×</button>
                </div>

                <div className="graph-import-file">
                    <div>
                        <span>Файл графика</span>
                        <strong>{fileName}</strong>
                    </div>
                    <small>Дата графика: {xlsDate || 'не определена'}</small>
                </div>

                <div className="graph-import-summary">
                    <span>Листов найдено: <strong>{availableSheets.length}</strong></span>
                    <span>Строк графика: <strong>{rowsCount}</strong></span>
                    <span>Колонок в шапке: <strong>{xlsHeaderCount || '—'}</strong></span>
                    <span className={statusClassName}>Статус: <strong>{statusText}</strong></span>
                </div>

                <div className="graph-import-steps">
                    <ProgressStepBar steps={steps} activeStepIndex={activeStepIndex}/>
                    {pgVisible && (
                        <ProgressLine
                            value={pgLineValue}
                            steps={['10%', '20%', '30%', '40%', '50%', '60%', '70%', '80%', '90%', '100%']}
                            getItemLabel={(item) => item}
                        />
                    )}
                </div>

                <div className={`graph-import-message ${statusClassName}`}>
                    {isFinishImport === 'ready'
                        ? "Файл проверен. Можно загрузить данные в график."
                        : isFinishImport === 'success'
                            ? "Импорт данных завершён успешно."
                            : isFinishImport === 'error'
                                ? renderTextErrors()
                                : "Нажмите «Проверить файл», чтобы проверить дни 1-31, план, кусты и скважины."}
                </div>

                <div className="graph-import-actions">
                    <Button
                        size="m"
                        view="secondary"
                        label="Закрыть"
                        width="default"
                        onClick={onClose}
                        disabled={isCloseDisabled}
                    />
                    <div className="graph-import-actions-main">
                        <Button
                            size="m"
                            view="primary"
                            label="Проверить файл"
                            width="default"
                            onClick={handleValidate}
                            disabled={isSaveDisabled}
                        />
                        <Button
                            size="m"
                            view="primary"
                            label="Загрузить в график"
                            width="default"
                            onClick={handleUpload}
                            disabled={isSaveDisabled || !isValidated}
                        />
                    </div>
                </div>
            </div>
        </Modal>
    );
}
export default ModalGraphImportXLS;
